import * as React from "react";
import { DOMAIN } from "../apiCalls";

const AcceptRegulations: React.FC = () => {
  return (
    <div>
      <p>Potwierdzenia regulaminów.</p>

      <div className="form-check">
        <input
          className="form-check-input"
          name="regulations"
          type="checkbox"
          value=""
          required
        />
        <label className="form-check-label" htmlFor="regulations">
          Akceptuj <a href={`${DOMAIN}/upload/regulamin.pdf`}>regulamin</a> i <a href={`${DOMAIN}/upload/klauzula.pdf`}>klauzulę</a> aby
          kontynuować sprzedaż
        </label>
      </div>
    </div>
  );
};

export default AcceptRegulations;
